export default "__VITE_ASSET__cacabe60__"